import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              {t('categories.title')}
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              {t('categories.subtitle')}
            </p>
          </div>
          <Link
            to="/category/sports"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('categories.view_all')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${category.icon} text-xl`} />
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                {category.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {category.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-xs font-medium text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>探索更多</span>
                <i className="ri-arrow-right-line" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}